import articleHeroMapping from "../components/articleHeroMapping";
import accordionMapping from "../components/accordionMapping";
import simpleTextMapping from "../components/simpleTextMapping";
import mediaTextMapping from "../components/mediaTextMapping";
import viewRelatedProductComponent from '../components/viewRelatedProductsComponent';

const articleMapping = (data) =>
{
  const mappedData = {};
  let pageData = JSON.parse(data['resolvedResource#uri{0}'].body);
  let components = pageData.data?.relationships?.field_components?.data;

  mappedData.title = pageData.data?.attributes?.title;

  const relatedProductsComponent = components.find(component =>
    component.type === "paragraph--related_products_component"
  );

  mappedData.hero = articleHeroMapping(components.find(component => {
    return component.type === "paragraph--article_hero_component"
  }));

  components = components.filter(component => {
    return component.type !== "paragraph--article_hero_component"
  })

  mappedData.content = components.map((component) => {
    switch (component.type) {
      case "paragraph--simple_text_component":
        return { simpleText: simpleTextMapping(component) };
      case "paragraph--media_text_component":
        return { mediaText: mediaTextMapping(component) };
      case "paragraph--accordion_component":
        return { accordion: accordionMapping(component) };
    }
  }).filter(function (element) {
    return element !== undefined;
  });

  if (relatedProductsComponent) {
    mappedData.viewRelatedProduct = viewRelatedProductComponent(relatedProductsComponent);
  }

  return mappedData;
}

export default articleMapping;
